const state = {
}

const mutations = {
    
}

const actions = {

}
export default {
    state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js